/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2017, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/messaging/connectors/index',['./slack/SlackConnector', './msteams/MSTeamsConnector', './email/EmailConnector'], function (SlackConnector, MSTeamsConnector, EmailConnector) {
	'use strict';
	// TODO: This is just to get going... we should take a "perspective" collection approach and load connectors on-demand.

	return {
		'slack': SlackConnector,
		'msteams': MSTeamsConnector,
		'email': EmailConnector
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

